export type EngVelocityFreshnessSource = "snapshot" | "live";

export type EngVelocityWindow = {
  since: string;
  until: string;
  days: number;
  label: string;
};

export type EngVelocityLocRow = {
  user: string;
  commits: number;
  additions: number;
  deletions: number;
  operatorCommits: number;
  operatorAdditions: number;
  operatorDeletions: number;
};

export type EngVelocityLocByRepoRow = EngVelocityLocRow & {
  repo: string;
};

export type EngVelocityPrRow = {
  user: string;
  opened: number;
  merged: number;
  closedUnmerged: number;
};

export type EngVelocityLinearRow = {
  user: string;
  deployedToProd: number;
};

export type EngVelocityTimeline = {
  days: string[];
  byDay: Record<string, Record<string, number>>;
};

export type EngVelocityFreshness = {
  loc: EngVelocityFreshnessSource;
  timeline: EngVelocityFreshnessSource;
  prs: EngVelocityFreshnessSource;
  linear: EngVelocityFreshnessSource;
};

export type EngVelocitySnapshotResponse = {
  generatedAt: string;
  window: EngVelocityWindow;
  repos: string[];
  loc: {
    source: EngVelocityLocRow[];
    all: EngVelocityLocRow[];
  };
  locByRepo?: {
    source: EngVelocityLocByRepoRow[];
    all: EngVelocityLocByRepoRow[];
  };
  prs: EngVelocityPrRow[];
  linear: EngVelocityLinearRow[];
  timeline: EngVelocityTimeline;
  freshness: EngVelocityFreshness;
  servedAt: string;
};

export function isEngVelocitySnapshotResponse(
  value: unknown,
): value is EngVelocitySnapshotResponse {
  if (!value || typeof value !== "object") {
    return false;
  }
  const body = value as Partial<EngVelocitySnapshotResponse>;
  return (
    typeof body.window?.since === "string" &&
    typeof body.window?.until === "string" &&
    Array.isArray(body.loc?.source) &&
    Array.isArray(body.loc?.all) &&
    Array.isArray(body.prs) &&
    Array.isArray(body.linear) &&
    Array.isArray(body.timeline?.days) &&
    typeof body.servedAt === "string"
  );
}
